import { render, staticRenderFns } from "./AddEditPostagemMidiaSociais.vue?vue&type=template&id=cdc207ae&scoped=true"
import script from "./AddEditPostagemMidiaSociais.vue?vue&type=script&lang=js"
export * from "./AddEditPostagemMidiaSociais.vue?vue&type=script&lang=js"
import style0 from "./AddEditPostagemMidiaSociais.vue?vue&type=style&index=0&id=cdc207ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc207ae",
  null
  
)

export default component.exports